import {IdlocaGeneric} from "../../../locales/IdlocaGeneric";
import {IGarageList} from "../../../interfaces/Interfaces";
import React from "react";
import {RenderRating} from "./RenderRating";
import {DetailsButton} from "./DetailsButton";
import {RenderGaragePhoto} from "../RenderGaragePhoto";
import {RenderGarageType} from "./RenderGarageType";
import {RenderCity} from "./RenderCity";

export interface IGarageListColumns {
    param: keyof IGarageList;
    locaId: IdlocaGeneric | string;
    renderer?: React.FC<{value: any; handleDetailsClick?: () => void}>;
    cellStyle?: React.CSSProperties;
}

export const GarageListColumns: IGarageListColumns[] = [
    {
        param: "placePhoto",
        locaId: "",
        renderer: RenderGaragePhoto,
    },
    {
        param: "name",
        locaId: IdlocaGeneric.name,
    },
    {
        param: "type",
        locaId: IdlocaGeneric.type,
        renderer: RenderGarageType,
    },
    {
        param: "city",
        locaId: IdlocaGeneric.city,
        renderer: RenderCity,
    },
    {
        param: "address",
        locaId: IdlocaGeneric.address,
    },
    {
        param: "rating",
        locaId: IdlocaGeneric.rating,
        renderer: RenderRating,
    },
    {
        param: "id",
        locaId: " ",
        renderer: DetailsButton,
    },
];
